import {MaterialStorage, MaterialType} from '@domain/material-storage'
import {ContentBox, ContentMode} from '@hconnect/common/components/ContentBox'
import {TabsPanel, Tab} from '@hm/fundamental'
import {Box, Typography} from '@mui/material'
import {AxiosError} from 'axios'
import React, {memo} from 'react'
import {useTranslation} from 'react-i18next'

import {SILO_FILL_LEVELS_WIDGET_NAMESPACE, TAB_CONFIG} from '../consts'

import {SilosDataTable} from './SilosDataTable'

type Props = {
  contentMode: ContentMode
  isLoading?: boolean
  error?: AxiosError | null
  materialStorageData?: MaterialStorage[]
  plantCode: string
  setSelectedMaterialType: (type: MaterialType) => void
  snapshotDateTime: string
}

export const MaterialStorageContainer: React.FC<Props> = memo(
  ({
    contentMode,
    error,
    isLoading,
    materialStorageData,
    plantCode,
    setSelectedMaterialType,
    snapshotDateTime
  }) => {
    const {t} = useTranslation(SILO_FILL_LEVELS_WIDGET_NAMESPACE)

    const errorMessage = error ? t('fetchingError') : undefined

    return (
      <ContentBox
        title={t('siloFillLevels')}
        mode={contentMode}
        bodyWithPadding
        isLoading={isLoading}
        errorMessage={errorMessage}
        data-test-id={'material-storage-container'}
      >
        <Typography alignItems="center" sx={{mb: 2}} variant="body2">
          {snapshotDateTime}
        </Typography>
        <Box sx={{mt: 2}}>
          <TabsPanel onSelect={(value: string) => setSelectedMaterialType(value as MaterialType)}>
            {TAB_CONFIG.map((tab) => (
              <Tab
                key={tab.key}
                label={t(tab.labelKey)}
                value={tab.key}
                data-testid={`materialStorage-tab-${tab.key}`}
              />
            ))}
          </TabsPanel>
          <SilosDataTable
            silos={materialStorageData ?? []}
            loading={isLoading}
            plantCode={plantCode}
          />
        </Box>
      </ContentBox>
    )
  }
)
